import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const EllipsisHorizontal = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M7.94629 12C7.94629 13.1046 7.05086 14 5.94629 14C4.84172 14 3.94629 13.1046 3.94629 12C3.94629 10.8954 4.84172 10 5.94629 10C7.05086 10 7.94629 10.8954 7.94629 12ZM21.9463 12C21.9463 13.1046 21.0509 14 19.9463 14C18.8417 14 17.9463 13.1046 17.9463 12C17.9463 10.8954 18.8417 10 19.9463 10C21.0509 10 21.9463 10.8954 21.9463 12Z"
      fill="#111111"
    />
    <path
      d="M14.9463 12C14.9463 13.1046 14.0509 14 12.9463 14C11.8417 14 10.9463 13.1046 10.9463 12C10.9463 10.8954 11.8417 10 12.9463 10C14.0509 10 14.9463 10.8954 14.9463 12Z"
      fill="#AAAAAA"
    />
  </svg>
)

export default withDefaultStyles(EllipsisHorizontal)
